import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
import { useApiError } from '../useApiError';
export const useCredential = (orderId: string): any => {
  // Loads context used to call API endpoint
  const context = useVSFContext();
  const { set: setError } = useApiError();
  // //console.log("useOauthmethodcontext---------", context.useApiError);

  // Shared ref holding the response from the API
  const result = sharedRef(null, `useCredential-${orderId}`);

  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `useCredential-loading-${orderId}`);

  // Shared ref holding errors from the methods
  const error = sharedRef(null, `useCredential-error-${orderId}`);
  // 刷新token
  const getPinJu = async (customQuery) => {
    const res = await context.$xbuy.api.paymentCredential(customQuery);
    if (res.code === 0) {
      // context.$cookies.set('token', res.data.token);
      result.value = res.data;
    } else {
      error.value = res.message;
      setError({ code: res.code, message: res.message });
    }
    // const data = await params.load(context);
    return res;
  };

  return {
    getPinJu,
    result: computed(() => result.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
